<div class="container-fluid blog-page filter-page">
  <div *ngIf="!issue" class="row">
    
  </div>

  <div *ngIf="issue" class="row">
    <div class="col-xl-3 xl-40 box-col-5">
      <div class="job-sidebar md-sidebar">
        <div class="md-sidebar-aside job-left-aside custom-scrollbar custom-scrollbar">
          <div class="default-according style-1 job-accordion" id="accordionoc">
            <div class="row">
              <div class="col-xl-12">
                <div class="card">
                  <div class="card-header">
                    <h5 class="mb-0 p-0">
                      <button class="btn btn-link"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseicon1">
                       Статус
                      </button>
                    </h5>
                  </div>
                  <div class="collapse show"
                       id="collapseicon1"
                       aria-labelledby="collapseicon1"
                       data-bs-parent="#accordion">
                    <div class="card-body p-0">
                      <ng-container *ngFor="let issue of issueStatuses">
                        <div class="categories">
                          <div class="learning-header adjust-learnings">
                            <span class="f-w-600">{{ issue.title }}</span>
                            <span *ngIf="issue.isCompleted" class="fa fa-check-square" style="color: green;"></span>
                            <span *ngIf="!issue.isCompleted" class="fa fa-square" style="color: grey;"></span>
                          </div> 
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-9 xl-60 box-col-7">
      <div class="blog-single">
        <div class="blog-box">
          <div class="card">
            <img class="img-fluid w-100"
                 src="assets/images/knowledgebase/bg_1.jpg"
                 alt="blog-main" />
          </div>
          <div class="card">
            <div class="card-body">
              <div class="blog-details">
                <h4 class="mt-0">Описание</h4>
                <div class="single-blog-content-top">
                  <p>
                    Knowledge can be defined as awareness of facts or as
                    practical skills, and may also refer to familiarity with
                    objects or situations. Knowledge of facts, also called
                    propositional knowledge, is often defined as true belief
                    that is distinct from opinion or guesswork by virtue of
                    justification. While there is wide agreement among
                    philosophers that it is a form of true belief, many
                    controversies in philosophy focus on justification: whether
                    it is needed at all, how to understand it, and whether
                    something else besides it is needed.
                  </p>
                  <p>
                    Knowledge can be produced in many different ways. The most
                    important source is perception, which refers to the usage of
                    the five senses. Many theorists also include introspection
                    as a source of knowledge, not of external physical objects,
                    but of one's own mental states. Other sources often
                    discussed include memory, rational intuition, inference, and
                    testimony. According to foundationalism, some of these
                    sources are basic in the sense that they can justify beliefs
                    without depending on other mental states. This claim is
                    rejected by coherentists.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
